import React, { useState } from "react";
import "./KeyFeatures.scss";
import ContentModule from "../../modules/content_module";
import { currency } from "../../common/constant";
import dateFormat from 'dateformat';

const Key = ({ property_data, globalModule }) => {
    const [show, setClass] = useState(false);

    const handleShow = () => {
        setClass(!show);
    }

    var description = property_data?.description ? property_data?.description : "";
    var long_description = property_data?.long_description ? property_data?.long_description : "";

    //console.log("availableFrom", new Date(property_data?.letting_info?.availableFrom).valueOf(), new Date().valueOf());

    //console.log("accomadation_summary", property_data?.accomadation_summary)

    return (
        <React.Fragment>
            <section className="key-features">
                {(Object.keys(property_data?.letting_info).length > 0) && property_data?.search_type === "lettings" &&
                    <div className="letting-info">
                        {/* <div className="h3">Letting Info</div> */}
                        <ul>
                            {property_data?.letting_info?.availableFrom &&
                                (new Date(property_data?.letting_info?.availableFrom).valueOf() > new Date().valueOf()
                                    ? <li>Available Date: {dateFormat(property_data?.letting_info?.availableFrom, "dd/mm/yyyy")}</li>
                                    : <li>Available Now</li>
                                )
                            }
                            {property_data?.letting_info?.deposit &&
                                <li>Deposit: {currency}{property_data?.letting_info?.deposit?.amount}</li>
                            }
                            {property_data?.letting_info?.term &&
                                <li>Type: {property_data?.letting_info?.term} Term</li>
                            }
                            {property_data?.letting_info?.furnishing && property_data?.letting_info?.furnishing?.length > 0 &&
                                <li>Furnish Type: {property_data?.letting_info?.furnishing[0]}</li>
                            }

                        </ul>

                    </div>
                }

                {(property_data?.accomadation_summary !== null && property_data?.accomadation_summary?.length > 0) && 
                <div className="key_features_content">
                    <div className="h3">Key Features</div>
                    {typeof property_data?.accomadation_summary === "object" ?
                        <ul>
                            {property_data?.accomadation_summary?.map((item, i) => {
                                return (
                                    <li key={i}>{item}</li>
                                )
                            })}
                        </ul>
                        :
                        <ul>
                            <ContentModule Content={property_data?.accomadation_summary?.replace(/•/g, '<li>').replace(/- /g, '<li>').replace(/\*/g, '<li>')} />
                        </ul>
                    }
                </div>
                }

                {(long_description || description) &&
                    <div className={show ? "summary show" : "summary"} >
                        <div className="h3">Summary</div>
                        {long_description ? 
                            <>
                                <p><ContentModule Content={description} /></p>
                                <p className="long_desc"><ContentModule Content={long_description} /></p>
                            </> 
                        : 
                            <>
                                <p className="long_desc"><ContentModule Content={description} /></p>
                            </>
                        }
                        <button className="more" onClick={handleShow} >Read {show ? "Less" : "Full"} Description</button>
                    </div>
                }

            </section>
        </React.Fragment>
    );
};
export default Key;
